module.exports = __webpack_public_path__ + "static/media/delivery.0f26dbd6.png";